import React from "react";
import BaseSettingsPage from "../../BaseSettingsPage";
import OnboardingNavigation from "../OnboardingNavigation";
import { StepHeader } from "./index";

class MemberBenefits extends React.Component {
  handleSaveResults = results => {
    if (results && !results.hasError) {
      return this.props.goForward();
    }
    return null;
  };

  render() {
    return (
      <div>
        <StepHeader>Looking to access savings and discounts that can help you run your business?</StepHeader>
        <BaseSettingsPage
          category="MemberBenefitInterests"
          handleSaveResults={this.handleSaveResults}
          renderSaveButton={saveHandler => (
            <OnboardingNavigation {...this.props} goForward={saveHandler} />
          )}
        />
      </div>
    );
  }
}

export default MemberBenefits;



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/Steps/MemberBenefits.js